import { render, staticRenderFns } from "./trainAppear.vue?vue&type=template&id=56daaac6&scoped=true"
import script from "./trainAppear.js?vue&type=script&lang=js&external"
export * from "./trainAppear.js?vue&type=script&lang=js&external"
import style0 from "./trainAppear.less?vue&type=style&index=0&id=56daaac6&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56daaac6",
  null
  
)

export default component.exports